import { defaultNotSelectedDate } from '../constants/constants';

export function getExperienceEndDateString(
  date: string | number,
  translatedActual: string
): string {
  if (date === defaultNotSelectedDate || date === 1900) return translatedActual;
  return date.toString();
}
